module.exports = __webpack_public_path__ + "nc_static/media/notification-preferences.b7bc1ed1.svg";